import { useRef } from 'react';
import { Button, ModalBody } from 'reactstrap';
import styled from 'styled-components';
import IconButton from '../../basics/IconButton';
import Modal from '../../basics/Modal';

const MessagesPre = styled.pre`
  max-height: 25vh;
`;

const ImportKmlButton = ({
  onParse = () => {},
  messages = {},
  setMessages = () => {},
  render,
  ...buttonProps
}) => {
  const file = useRef();
  const clearMessages = () => {
    setMessages({});
  };

  const handleFile = (e) => {
    const reader = new FileReader();
    // get filename without .kml extension
    const strippedFilename =
      e.target.files[0]?.name?.replace(/\.[^/.]+$/, '') || '';
    reader.addEventListener('load', (event) => {
      const parsedKml = new DOMParser().parseFromString(
        event.target.result,
        'text/xml',
      );
      // Parse as XML and check for errors
      if (!parsedKml || parsedKml.querySelector('parsererror')) {
        setMessages({
          info: 'Imported KML file is not valid XML',
        });
        return;
      }
      try {
        onParse(parsedKml, strippedFilename);
      } catch (err) {
        console.error(err);
        setMessages({
          info: 'An error occurred while parsing the imported KML',
        });
      }
    });
    reader.readAsText(e.target.files[0]);
    e.target.value = null;
  };
  return (
    <>
      {render ? (
        render(() => file.current.click())
      ) : (
        <IconButton {...buttonProps} onClick={() => file.current.click()} />
      )}
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label -- hidden element should not have label */}
      <input
        type="file"
        ref={file}
        className="d-none"
        accept=".kml"
        onChange={handleFile}
      />
      {messages.info && (
        <Modal isOpen={!!messages.info} toggle={clearMessages} centered>
          <ModalBody className="font-large">
            <h4>{messages.info}</h4>
            {messages.error && (
              <>
                <h4>Errors:</h4>
                <MessagesPre className="text-danger mt-2">
                  {messages.error}
                </MessagesPre>
              </>
            )}
            {messages.warning && (
              <>
                <h4>Warnings:</h4>
                <MessagesPre className="text-warning mt-2">
                  {messages.warning}
                </MessagesPre>
              </>
            )}
            <Button
              onClick={clearMessages}
              color="primary"
              size="sm"
              className="pull-right"
            >
              Close
            </Button>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default ImportKmlButton;
